import LoginComp from './english/LoginComp';
import RegisterComp from './english/RegisterComp';
import DashboardComp from './english/DashboardComp';
import InfoComp from './english/InfoComponent';
import ProfileComp from './english/SettingsComp';
import EventComp from './english/MakeNewEvent';
import MapComp from './english/MapComponent';
import ReportComp from './english/ReportComponent';
import InfoEventComp from './english/InfoEventComponent';

import FRDashboardComp from './french/FRDashboardComp';
import FRInfoComp from './french/FRInfoComp';
import FRProfileComp from './french/FRSettingsComp';
import FREventComp from './french/FRMakeNewEventComp';
import FRReportComp from './french/FRReportComp';
import FRInfoEventComp from './french/FRInfoEventComp';
import FRMapComponent from './french/FRMapComponent';

import DUDashboardComp from './dutch/DUDashboardComp';
import DUInfoComp from './dutch/DUInfoComp';
import DUProfileComp from './dutch/DUSettingsComp';
import DUEventComp from './dutch/DUMakeNewEventComp';
import DUReportComp from './dutch/DUReportComp';
import DUInfoEventComp from './dutch/DUInfoEventComp';
import DUMapComp from './dutch/DUMapComponent';

export {
  LoginComp, RegisterComp, DashboardComp,
  InfoComp, ProfileComp, EventComp, MapComp, ReportComp,
  InfoEventComp, FRInfoEventComp, FRDashboardComp, FRInfoComp,
  FRProfileComp, FREventComp, FRMapComponent, FRReportComp, DUDashboardComp,
  DUInfoComp, DUProfileComp, DUEventComp, DUReportComp,
  DUInfoEventComp, DUMapComp,
};
